import { Component, OnInit } from '@angular/core';

import { MatDividerModule } from '@angular/material/divider';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CardComponent } from '../home-page/card/card.component';
import { Router } from '@angular/router';
import { Broadcast } from 'src/app/core/services/broadcast.service';
import { Role } from '@models/enums';
import { RoleService } from 'src/app/core/services/role.service';

@Component({
    selector: 'app-administration',
    imports: [MatDividerModule, ArianeNavComponent, MatIconModule, MatButtonModule, CardComponent],
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit {
  arianeLabel: string = 'Administration';
  arianeIcon: string = 'settings';
  userRoles: Role[] = [];
  public homeCards = [
    {
      icon: 'person',
      title: 'Gestion des utilisateurs',
      body: 'Accéder à la gestion des délégations pour chaque utilisateur',
      link: 'GESTION DES DELEGATIONS',
      routerLink: 'pama/administration/gestion-delegations',
      requiredRoles: [Role.PAMA_ADMIN],
      show: false
    },
    {
      icon: 'system_update_alt',
      title: 'Suivi des imports et exports',
      body: 'Suivre les traitements périodiques d’importation du référentiel',
      link: 'SUIVIE IMPORTS',
      routerLink: 'pama/administration/suivi-imports',
      requiredRoles: [Role.PAMA_ADMIN],
      show: false
    },
    {
      icon: 'settings_applications',
      title: 'Paramètres de configuration',
      body: 'Accéder aux paramètres de configuration',
      link: 'PARAMETRES',
      routerLink: 'pama/administration/parametres_de_configurations',
      requiredRoles: [Role.PAMA_ADMIN],
      show: false
    },
    {
      icon: 'list_alt',
      title: 'Liste des postes',
      body: 'Accéder à la liste des postes',
      link: 'LISTE POSTES',
      routerLink: 'pama/administration/liste-postes',
      requiredRoles: [Role.PAMA_ADMIN],
      show: false
    },
    {
      icon: 'view_list',
      title: 'Gestion des services',
      body: 'Accéder au référentiel des services. Les Services sont créées automatiquement au besoin lors de la mise à jour des agents.',
      link: 'GESTION SERVICES',
      routerLink: 'pama/administration/gestion-services',
      requiredRoles: [Role.PAMA_ADMIN],
      show: false
    },
    {
      icon: 'border_all',
      title: 'Gestion des directions',
      body: 'Accéder au référentiel des directions. Les directions sont créées automatiquement au besoin lors de la mise à jour des agents.',
      link: 'GESTION DIRECTIONS',
      routerLink: 'pama/administration/gestion-directions',
      requiredRoles: [Role.PAMA_ADMIN],
      show: false
    }
  ];

  constructor(
    private readonly redirection: Broadcast,
    private readonly router: Router,
    private readonly roleService: RoleService
  ) {}
  ngOnInit() {
    this.roleService.getRole().subscribe((roles) => {
      this.userRoles = roles as Role[];
      this.accessToCard();
    });
  }
  navigateToCard(section: any) {
    this.router.navigateByUrl(section.routerLink);

    this.redirection.broadcastEvent(section.link);
  }
  accessToCard() {
    this.homeCards.forEach((card) => {
      card.show = this.roleService.canAccess(card.requiredRoles);
    });
  }
}
